import { render, staticRenderFns } from "./AsusRouter.vue?vue&type=template&id=ba8962a2&scoped=true&"
import script from "./AsusRouter.vue?vue&type=script&lang=js&"
export * from "./AsusRouter.vue?vue&type=script&lang=js&"
import style0 from "./AsusRouter.vue?vue&type=style&index=0&id=ba8962a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba8962a2",
  null
  
)

export default component.exports